import React, { Fragment } from 'react';
import styles from '../styles/components/ExpandableContent.module.css';
import AnimateHeight from 'react-animate-height';
import separatorIcon from '../assets/line_separator_grey.svg';
import upIcon from '../assets/chevron_up_red.svg';
import downIcon from '../assets/chevron_down_red.svg';
import _ from 'lodash';

export interface ExpandableContentData {
  title?: string;
  subtitle?: string;
  tag?: JSX.Element;
  expandLabel: string;
  reduceLabel: string;
  actions: JSX.Element[];
  previewContent: JSX.Element;
  expandedContent: JSX.Element;
  isExpanded?: boolean;
  onExpand: (state: boolean) => void;
}

export const ExpandableContent: React.FC<ExpandableContentData> = props => {
  return (
    <div className={styles.expandableContent}>
      <div className={styles.header}>
        <div className={styles.headerContainer}>
          <div className={styles.titleContainer}>
            {props.title && <span className={styles.title}>{props.title}</span>}
            {props.subtitle && (
              <span className={styles.tSeparator}>&nbsp;—&nbsp;</span>
            )}
            {props.subtitle && (
              <span className={styles.subtitle}>{props.subtitle}</span>
            )}
          </div>
          {props.tag && props.tag}
        </div>
        <div className={styles.actionsContainer}>
          {_.map(props.actions, (action, index) => {
            return index === 0 ? (
              <div className={styles.action} key={index}>
                {action}
              </div>
            ) : (
              <Fragment key={index}>
                <div className={styles.actionSeparator}>
                  <img src={separatorIcon} alt="separator" />
                </div>
                <div className={styles.action}>{action}</div>
              </Fragment>
            );
          })}
        </div>
      </div>
      <div className={styles.content}>
        <AnimateHeight
          delay={!props.isExpanded ? 600 : 0}
          duration={600}
          height={!props.isExpanded ? 'auto' : 0}
        >
          {props.previewContent}
        </AnimateHeight>
        <AnimateHeight
          delay={props.isExpanded ? 600 : 0}
          duration={600}
          height={props.isExpanded ? 'auto' : 0}
        >
          {props.expandedContent}
        </AnimateHeight>
      </div>
      <div
        className={styles.footer}
        onClick={() => props.onExpand(!props.isExpanded)}
      >
        <span>{props.isExpanded ? props.reduceLabel : props.expandLabel}</span>
        {props.isExpanded ? <img src={upIcon} /> : <img src={downIcon} />}
      </div>
    </div>
  );
};
